import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import SplitScriptureView from './SplitScriptureView';
import SplitMovementsView from './SplitMovemenstView';

import { useSplitModal } from '../context/SplitModalContext';

const SplitModalBody: FC = () => {
  const { data } = useSplitModal();

  return (
    <Modal.Body style={data.scriptureView ? {} : { minHeight: '281px' }}>
      <div className="nk-modal">
        {data.scriptureView ? <SplitScriptureView /> : <SplitMovementsView />}
      </div>
    </Modal.Body>
  );
};

export default SplitModalBody;
